const shared_trustmarks = {
  positiveSSL: {
    type: 'img',
    url: null,
    src: 'https://static.uniid.it/JaIdeHOwyGgPQhOLjgIHR4rTZL4',
    alt: 'PossitiveSSL Trustmark'
  }
};

const trustmarks_data = {
  1: [
    {
      type: 'svg',
      name: 'da',
      online: false,
      url: 'https://certifikat.emaerket.dk/unisport.dk/'
    },
    {
      type: 'svg',
      name: 'da_dbu',
      online: true,
      url: 'https://www.unisport.dk/blog/13220-unisport-bliver-partner-pa-dbu-fodboldskole/'
    }
  ],
  10: [
    {
      type: 'svg',
      name: 'se',
      online: true,
      url: 'https://dhandel.se/trygg-e-handel/certifierade-e-handlare/?id=862'
    }
  ],
  12: [
    {
      type: 'svg',
      name: 'no_nff',
      online: true,
      url: 'https://www.unisportstore.no/blog/13745-unisport-i-samarbeid-med-nff-og-nike/'
    }
  ],
  13: [
    {
      type: 'img',
      name: 'fi',
      online: false,
      url: ' https://suomenvarmakauppa.fi/kauppa/119/unisportstore.fi',
      src: 'https://static.uniid.it/RcsYqBdkn9qAUNbepY8DS8oliS',
      alt: 'Suomi Trusmark'
    },
    {
      type: 'svg',
      name: 'fi_jpy',
      online: true,
      url: null
    }
  ],
  14: [
    {
      type: 'img',
      name: 'nl',
      online: false,
      url: 'https://www.thuiswinkel.org/leden/unisportstore.nl/certificaat',
      src: 'https://static.uniid.it/OjEzFB4FYkNh3Qxaypv792QKD3P',
      alt: 'Nederland Trustmark'
    }
  ],
  15: [
    {
      name: 'de-positive-ssl',
      online: true,
      ...shared_trustmarks.positiveSSL
    }
  ],
  22: [
    {
      name: 'european trustmark',
      type: 'img',
      online: true,
      url: null,
      src: 'https://static.uniid.it/O9ZmVwdaDC5uimdQhk2U8gLeRFJ',
      alt: 'european trustmark'
    }
  ]
};

export default trustmarks_data;
